const DEFAULT_PLUS_MENU_ORDER = 0;
/** Every plus-menu item across the mounted plugins, ordered for rendering. */
export async function collectPlusMenuItems(plugins) {
    let registrationIndex = 0;
    const pluginItemLoaders = plugins.flatMap((plugin) => (plugin.plusMenu ?? []).map(async (loadItems) => {
        try {
            return {
                plugin,
                contributions: await loadItems(),
            };
        }
        catch {
            // TODO(#input-box): Log plus-menu loader failures once client-side reporting is wired here.
            return {
                plugin,
                contributions: [],
            };
        }
    }));
    const loadedPluginItems = await Promise.all(pluginItemLoaders);
    return loadedPluginItems
        .flatMap(({ plugin, contributions }) => contributions.map((contribution) => ({
        pluginId: plugin.id,
        contribution,
        props: plugin.props,
        registrationIndex: registrationIndex++,
    })))
        .sort(comparePlusMenuItems);
}
function comparePlusMenuItems(left, right) {
    const orderDifference = (left.contribution.order ?? DEFAULT_PLUS_MENU_ORDER) -
        (right.contribution.order ?? DEFAULT_PLUS_MENU_ORDER);
    return orderDifference === 0 ? left.registrationIndex - right.registrationIndex : orderDifference;
}
//# sourceMappingURL=collectPlusMenuItems.js.map